import { Injectable } from '@angular/core';
import { LoaderService } from './loader.service';
import { HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService {

  constructor(private loaderService: LoaderService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.loaderService.show();

    if(req.url.includes('opd-service/api/patient/init-data')){
      setTimeout(() => { this.loaderService.hide()}, 500);
    }

    if(req.url.includes('https://triage.rafayethrafi.engineer/api/v1/ocr-images')){
      setTimeout(() => { this.loaderService.hide()}, 500);
    }

    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.loaderService.hide();
      }
    },
      (err: any) => {
        this.loaderService.hide();
      }));
  }

}
